'use client';
import Script from 'next/script';
import { useClientOnlyMediaQuery } from '~/common/hooks/use-client-only-media-query';
import { useVipStateWithCache } from '~/common/hooks/use-vip-state-with-cache';
import { Media } from '~/utils/styles/enums';
import { Center } from '@styled-system/jsx';

export const InStreamAdContainer = () => {
  const screenLarge = useClientOnlyMediaQuery(Media.LARGE);
  const isMobile =
    typeof screenLarge === 'undefined' ? undefined : !screenLarge;
  const { storedVipState } = useVipStateWithCache();

  if (storedVipState || typeof isMobile === 'undefined') return null;

  return (
    <>
      {isMobile ? (
        <>
          <Center
            className="gliaplayer-container"
            data-slot="imobile_teller_mobile"
          ></Center>
          <Script
            id="instream-mobile-script"
            src="https://player.gliacloud.com/player/imobile_teller_mobile"
            async
          />
        </>
      ) : (
        <>
          <Center
            className="gliaplayer-container"
            data-slot="imobile_teller_desktop"
          ></Center>
          <Script
            id="instream-pc-script"
            src="https://player.gliacloud.com/player/imobile_teller_desktop"
            async
          />
        </>
      )}
    </>
  );
};
